import { useRouter } from "next/router";
import React, { useEffect, useState } from "react";
import Loader from "../../../../components/Loader";
import { randomString } from "../../../../helpers/helperFunctions";
import axios from "axios";
import { API_URL } from "../../../../config";
import { useTranslation } from "react-i18next";

const Invite = () => {
  const router = useRouter();
  const { t } = useTranslation("common-page");
  const [routerData, setRouterData] = useState<any>("");
  useEffect(() => {
    setRouterData(JSON.stringify(router.query));
  }, [router.query]);

  const setAuthHeader = (token: string) => {
    return {
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
  };
  useEffect(() => {
    let u = JSON.parse(localStorage.getItem("user-info")!);
    if (routerData !== "") {
      if (u == null) {
        let url = new URL("accept_collaboration_invitation", API_URL);
        let userID = "DuVqTE";
        let uToken = "null";
        url.searchParams.append("user_id", userID);
        url.searchParams.append("keygen", router?.query.key as string);

        axios
          .post(url.toString(), {}, setAuthHeader(uToken))
          .then((res: any) => {
            if (res.statusText == "OK") {
              router.push({
                pathname: `/collab-strategy-new/${encodeURIComponent(userID)}/${
                  res.data?.id + randomString(5)
                }/${uToken}/false`,
                query: {
                  ref: router.asPath,
                  locale: router.query.locale || "en",
                },
              });
            }
          })
          .catch((err) => {
            console.warn("err", err);
          });
        return;
      } else if (router?.query?.invite) {
        let url = new URL("accept_collaboration_invitation", API_URL);
        url.searchParams.append("user_id", u?.user_id);
        url.searchParams.append("keygen", router?.query.key as string);
        axios
          .post(url.toString(), {}, setAuthHeader(u.token))
          .then((res: any) => {
            if (res.statusText == "OK") {
              router.push({
                pathname: `/collab-strategy/${encodeURIComponent(u?.user_id)}/${
                  res.data?.id + randomString(5)
                }/${u.token}/false`,
                query: {
                  ref: router.asPath,
                  locale: router.query.locale || "en",
                },
              });
            }
          });
      }
    }
  }, [routerData]);
  return (
    <div className="absolute flex justify-center items-center w-full h-screen z-[999999]">
      <Loader text={t("Loading")} />
    </div>
  );
};

export default Invite;
